import {IndustryGroup, industryGroupDescription} from "../types/IndustryGroup";

export const IndustryGroupFilter = "industryGroup";

export function industryGroupFilter() {
    return function(group: IndustryGroup | null): string | null {
        if (group == null) {
            return null;
        } else {
            return industryGroupDescription(group);
        }
    }
}